<template>
  <div>
    <Header />
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1 class="dashboard-header">
            <span class="stat-chip">{{year}} YILI DELGİ SAYISI = {{ raporlar.yillik }}</span>
            <span class="stat-chip">AYLIK DELGİ SAYISI = {{ raporlar.aylik }}</span>
            <span class="stat-chip">DÜNKÜ DELGİ SAYISI = {{ raporlar.dunku }}</span>
            <span class="stat-chip highlight">GÜNLÜK ORTALAMA = {{ raporlar.ortalama }}</span>
            <span class="action-chip" @click="openDocument()">ÖZET</span>
            <span
              class="action-chip"
              @click="routeToDo(item)"
              v-if="gorev.length > 0"
            >
              GÖREVLER : {{ gorev.length }} ADET
            </span>
          </h1>
        </div>
      </div>

      <div style="margin:auto ; position : center" aria-labelledby="navbarDropdown">
        <!-- <input class="form-control py-2 border-left-0 border" type="search" value="..." id="example-search-input"> -->
        <input class="form-control py-2 border-left-0 border" style="width:100%;border-radius:0.25rem" type="search"
          v-model="searchString" placeholder="ARATMAK İSTEDİĞİNİZ SAHAYI YAZINIZ" />
        <div style="width: 500px;position: absolute; z-index:3;">
          <ul class="searchCss" style="">
            <li v-for="result in results" :key="result.id">
              <hr />
              <div @click="routeDetail(result)"
                style="padding-right: 5px;padding-left: 5px;font-size: 15px;color: black;">

                {{ result.id + "~" + result.sahaName}}

              </div>
            </li>
          </ul>
        </div>
      </div>
<br>
      <div class="row">
        <div class="col-lg-12 col-md-12 justify-content-md-center rowHomepage" >
          <div v-for="(item, index) in sahalar" :key="index" class="col-md-3 col-lg-3"
            style="margin-bottom: 22px; height:110px" v-if="sahalar[index].isyuzdesi < 100">
            <!-- -1 olması gerek aşağıda now dateden sonra  -->
            <div v-if="sahalar[index].reg_date == nowdate" style=" 
            background-color: rgb(120, 211, 167);
            display: flex;
            justify-content: center;
            align-items: center;
          " class="tileHomepage hover-div2">
              <div class="about-content">
                <div>
                  <p v-if="sahalar[index].isyuzdesi <= 25 &&
              sahalar[index].isyuzdesi >= 0
              " @click="routePage(item)" id="kirmizi">
                    {{ sahalar[index].id }} -
                    {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}%
                  </p>
                  <p v-if="sahalar[index].isyuzdesi <= 55 &&
              sahalar[index].isyuzdesi >= 26
              " @click="routePage(item)" id="turuncu">

                    {{ sahalar[index].id }} -
                    {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}%
                  </p>
                  <p v-if="sahalar[index].isyuzdesi <= 75 &&
              sahalar[index].isyuzdesi >= 56
              " @click="routePage(item)" id="sari">
                    {{ sahalar[index].id }} -
                    {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}%
                  </p>
                  <p v-if="sahalar[index].isyuzdesi <= 99 &&
              sahalar[index].isyuzdesi >= 76
              " @click="routePage(item)" id="yesil">
                    {{ sahalar[index].id }} -
                    {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}%
                  </p>
                  <p v-if="sahalar[index].isyuzdesi <= 100 &&
              sahalar[index].isyuzdesi >= 100
              " @click="routePage(item)" id="mavi">
                    {{ sahalar[index].id }} -
                    {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}%
                  </p>
                </div>
              </div>
            </div>
            <div v-else style="
            background-color: rgb(221, 221, 221);
            display: flex;
            justify-content: center;
            align-items: center;
          " class="tileHomepage hover-div2">
              <div class="about-content">
                <div>
                  <p v-if="sahalar[index].isyuzdesi <= 25 &&
              sahalar[index].isyuzdesi >= 0
              " @click="routePage(item)" id="kirmizi">
              {{ sahalar[index].id }} -
                    {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}%
                  </p>
                  <p v-if="sahalar[index].isyuzdesi <= 55 &&
              sahalar[index].isyuzdesi >= 26
              " @click="routePage(item)" id="turuncu">
              {{ sahalar[index].id }} -
                    {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}%
                  </p>
                  <p v-if="sahalar[index].isyuzdesi <= 75 &&
              sahalar[index].isyuzdesi >= 56
              " @click="routePage(item)" id="sari">
              {{ sahalar[index].id }} -
                    {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}%
                  </p>
                  <p v-if="sahalar[index].isyuzdesi <= 99 &&
              sahalar[index].isyuzdesi >= 76
              " @click="routePage(item)" id="yesil">
              {{ sahalar[index].id }} -
                    {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}%
                  </p>
                  <p v-if="sahalar[index].isyuzdesi <= 100 &&
              sahalar[index].isyuzdesi >= 100
              " @click="routePage(item)" id="mavi">
              {{ sahalar[index].id }} -
                    {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}%
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
import { debounce } from "lodash";
export default {
  data() {
    return {
      searchString: "",
      results: [],
      product: [],
      year : new Date().getFullYear(),
      sahalar: [],
      raporlar: [],
      aylık: 12313,
      dunku: 123,
      yıllık: 1231231,
      ortalama: 123,
      nowdate: "",
      nowyear: "",
      nowmonth: "",
      getFullYearAll: "",
      token: "",
      gorev: [],
      control: "",
    };
  },
  watch: {
    searchString: debounce(function () {
      this.search();
    }, 250),
    $route() {
      $("#navbarSupportedContent").collapse("hide");
    },
  },
  methods: {
    openDocument() {
    var id = localStorage.getItem("id");
    var token = localStorage.getItem("token");
      window.open(`https://www.apidosya.aslanyazilimm.com/DosyaApi/ozetSahalar.php?key=7264972863481679&idm=${token}$key=${id}`, "_blank");
    },
    routePage: function (item) {
      window.location.href = "#/mainPage?idm=" + item.id + item.keycode;
    },
    routeToDo: function (item) {
      window.location.href = "#/notifications?";
    },
    routeDetail: function (item) {
      window.location.href = "#/notesPage?idm=" + item.id +item.keycode;
    },
    search: function () {
      if (this.searchString.length > 0) {
        axios
          .get(
            `https://www.apidosya.aslanyazilimm.com/DosyaApi/AslanSahalar/searchSaha.php?key=123&keyword=${this.searchString}`
          )
          .then((response) => {
            var deger = response.data.length;
            if (deger > 50) {
              this.results = response.data.slice(0, 50);
            } else {
              this.results = response.data;
            }
          });
      } else {
        this.results = null;
      }
    },
  },
  mounted() {
    let date = new Date();
    this.nowdate = date.getDate();
    this.nowyear = date.getFullYear();
    this.nowmonth = date.getMonth() + 1;
    // console.log("*****" + this.nowdate);
    //this.getFullYearAll = this.nowdate + "." + this.nowmonth + "." + this.nowyear;
    this.getFullYearAll =
      this.nowyear + "-" + this.nowmonth + "-" + this.nowdate;
      // console.log(this.getFullYearAll);
    window.scrollTo(0, 0);

    var id = localStorage.getItem("id");
    var token = localStorage.getItem("token");
    if (!token) {
      alert(
        "Yetkisiz İşlem Yapılmaya Çalışıldı Giriş Sayfasına Yönlendirileceksiniz"
      );
      this.$store.dispatch("logout");
    }
    var datas = {
      id: id,
    };
    var url = store.state.base_url + "AslanSahalar/getAllSahaMain.php?key=123";
    axios
      .post(url, JSON.stringify(datas))
      .then((response) => {
        this.sahalar = response.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
    /////////////////////////////////////////////////////////////
    var datas = {
      id: id,
    };
    var url = store.state.base_url + "AslanSahalar/getgorev.php?key=123";
    axios
      .post(url, JSON.stringify(datas))
      .then((response) => {
        this.gorev = response.data.data

        // console.log(this.gorev)
      })
      .catch((err) => {
        console.log(err.response);
      });
    var datas = {

    };
    var url = store.state.base_url + "Raporlama/getDetayAllSaha.php?key=123";
    axios
      .post(url, JSON.stringify(datas))
      .then((response) => {
        this.raporlar = response.data

        // console.log(this.gorev)
      })
      .catch((err) => {
        console.log(err.response);
      });

    setTimeout(function () {
      //  alert("Sayfa yenilendi");
      window.location.reload(1);
    }, 2500000);
  },
  components: {
    Header,
    Sidebar,
  },
};
</script>

<style>
.col-md-3 {
  /* Burada, mobil ekranlarda 1 sütun genişliği belirleyebilirsiniz */
  width: 100%;
}

.rowHomepage {
  /* Satırların taşma yapmaması için esnek ayarlar yapabilirsiniz */
  display: flex;
  flex-wrap: wrap;
  /* Satırların alt alta yerleşmesini sağlar */
  justify-content: center;
  /* İçerikleri yatay olarak ortalar */
}

#kirmizi {
  border-radius: 15px 50px;
  background-color: #f77070;
  text-align: center;
  font-size: 25px;
}
.searchCss {
  border-radius: 6px;
  background-color: white;
}
#turuncu {
  border-radius: 15px 50px;
  background-color: #ff9900;
  text-align: center;
  font-size: 25px;
}

#sari {
  border-radius: 15px 50px;
  background-color: #f4ff2d;
  text-align: center;
  font-size: 25px;
}

#yesil {
  border-radius: 15px 50px;
  background-color: #76f118;
  text-align: center;
  font-size: 25px;
}

#mavi {
  border-radius: 15px 50px;
  background-color: #19c6f1;
  text-align: center;
  font-size: 25px;
}

#pid1:hover {
  border-radius: 15px 50px;
  background-color: #63ca92;
  text-align: center;
  font-size: 25px;
}

#pid2:hover {
  border-radius: 15px 50px;
  background-color: #63ca92;
  text-align: center;
  font-size: 25px;
}

#pid3:hover {
  border-radius: 15px 50px;
  background-color: #63ca92;
  text-align: center;
  font-size: 25px;
}

#pid4:hover {
  border-radius: 15px 50px;
  background-color: #63ca92;
  text-align: center;
  font-size: 25px;
}
.dashboard-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 14px;
  font-size: 18px;
  font-weight: 600;
  color: #1a2b3c;
  margin: 20px 0;
}

.stat-chip {
  background-color: #f4f7fa;
  border-radius: 16px;
  padding: 8px 14px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.06);
  transition: all 0.2s ease;
}

.stat-chip:hover {
  background-color: #e2ecf3;
  transform: scale(1.03);
}

.stat-chip.highlight {
  background-color: #fff;
  font-weight: 700;
  color: #0b69d8;
}

.action-chip {
  background-color: #8ccdcc;
  color: #fff;
  border-radius: 18px;
  padding: 8px 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.action-chip:hover {
  background-color: #6bbab9;
}

/* Responsive */
@media (max-width: 768px) {
  .dashboard-header {
    flex-direction: column;
    gap: 12px;
    font-size: 16px;
  }

  .stat-chip, .action-chip {
    width: 100%;
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Notes.vue